import { composeIO } from 'react-compose-io'
import { fieldsSubstituirIO } from './FieldsSubstituir.IO'
import { FieldsSubstituirView } from './FieldsSubstituir.View'

export const FieldsSubstituir = composeIO(FieldsSubstituirView, fieldsSubstituirIO)
